import React, { useState, useEffect } from 'react';
import Container from 'shared/container';
import Headline from 'shared/headline';
import Icon from 'icon';
import InfluencerCard from './infl-card';
import s from './top-influencers.module.scss';

function TopInfluencers({ influencers }) {


  const influencersRequested = influencers.filter(influencer => !influencer.completionStatus).sort((curr, next) => next.auditRequests - curr.auditRequests);


  return (
    <>
      <Container className={s.root}>
        <div className={s.wrapper}>
          <div className={`${s.flex} ${s.row}`}>
            <Headline className={s.title} html="Top Influencers Requested" />
            <a href="#allInfluencers" className={`${s.flex} ${s.row} ${s.margin}`}>
              <p className={s.text} dangerouslySetInnerHTML={{ __html: 'ALL INFLUENCERS REQUESTED' }} />
              <Icon className={s.icon} icon="arrow-circle" />
            </a>
          </div>
          <div className={s.flex}>
            {influencersRequested.map((influencer, i) => (
              i < 7 &&
              <InfluencerCard {...influencer} key={influencer.username} index={i} />
            ))}
          </div>
        </div>
      </Container>
    </>
  );
}
export default TopInfluencers;
